export const debounce = <T extends (...args: any[]) => any>(
    fn: T,
    ms = 300
) => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null
    let resolvers: ((val: Awaited<ReturnType<T>>) => void)[] = []

    return (...args: Parameters<T>): Promise<Awaited<ReturnType<T>>> => {
        return new Promise((resolve) => {
            if (timeoutId) clearTimeout(timeoutId)

            resolvers.push(resolve)

            timeoutId = setTimeout(async () => {
                const result = await fn(...args)
                resolvers.forEach((r) => r(result))
                resolvers = []
            }, ms)
        })
    }
}
